<template>
  <footer class="py-3 footer bg-black opacity-8">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-lg-6 mb-lg-0">
          <div
            class="text-xs text-center copyright text-white"
            :class="$store.state.isRTL ? 'text-lg-end' : 'text-lg-start'"
          >
            ©
            {{ new Date().getFullYear() }}
            <a href="https://kintsugi.ai" target="_blank">
              <span class="text-info">KINTSUGI.AI</span></a
            >
          </div>
        </div>
        <div class="col-lg-6">
          <ul
            class="nav nav-footer justify-content-center justify-content-lg-end"
          >
            <li class="nav-item">
              <a
                href="https://genodyne.ai"
                class="nav-link text-white opacity-7 text-uppercase"
                target="_blank"
                >About Genodyne</a
              >
            </li>
            <li class="nav-item">
              <a
                href="https://genodyne.ai/contact"
                class="nav-link text-white opacity-7 text-uppercase"
                target="_blank"
                >Contact Us</a
              >
            </li>
            <li class="nav-item">
              <a
                href="https://genodyne.ai/privacy-policy"
                class="nav-link pe-0 text-white opacity-7 text-uppercase"
                target="_blank"
                >Privacy Policy</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>
